import Table, { ColumnsType } from 'antd/es/table';
import React, { FC } from 'react';

import {
  GenerateReportActions,
  InputCheckbox,
  InputSelect,
  InputSelectList,
  InputText,
  Loader,
} from '../../../../components';
import { orderByOptions } from '../../../../utils';
import {
  StyledFiltersContainer,
  StyledTableContainer,
} from '../../../../utils/styles';
import { InputSelectListOption, PaginationData } from '../../../../utils/types';
import { AltPlainTruckData } from '../../../../utils/types/truck';
import { TableData } from '../../types';
import { sortByOptions, transformData } from './utils';

type Props = {
  data: AltPlainTruckData[];
  isLoading: boolean;
  paginationData: PaginationData;
  onFilter: {
    isInsurancePolicyExpired: (value: boolean) => void;
    licenseOrBrand: (value: string) => void;
    transport: (value: InputSelectListOption | null) => void;
    sortBy: (value: string) => void;
    orderBy: (value: string) => void;
  };
  transportFilterQuery: (value: string) => void;
  transportFilterOptions: InputSelectListOption[];
  onGenerateReportPDF: () => void;
  onGenerateReportXLXS: () => void;
};

const TrucksReportsTable: FC<Props> = ({
  isLoading,
  data,
  paginationData,
  onFilter,
  transportFilterQuery,
  transportFilterOptions,
  onGenerateReportPDF,
  onGenerateReportXLXS,
}) => {
  const newData = transformData(data);

  const columns: ColumnsType<TableData> = [
    { title: 'Transporte', key: 'transport', dataIndex: 'transport' },
    { title: 'Permiso', key: 'license', dataIndex: 'license' },
    { title: 'Paut', key: 'paut', dataIndex: 'paut' },
    { title: 'Patente', key: 'licensePlate', dataIndex: 'licensePlate' },
    { title: 'Nro. Chasis', key: 'chasisNumber', dataIndex: 'chasisNumber' },
    { title: 'Marca', key: 'brand', dataIndex: 'brand' },
    { title: 'Año', key: 'year', dataIndex: 'year' },
    {
      title: 'Nro. Póliza',
      key: 'insurancePolicyNumber',
      dataIndex: 'insurancePolicyNumber',
    },
    {
      title: 'Vto. Póliza',
      key: 'insurancePolicyExpirationDate',
      dataIndex: 'insurancePolicyExpirationDate',
    },
  ];

  const handleOnFilterInsurancePolicyExpired = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onFilter.isInsurancePolicyExpired(event.target.checked);
    },
    [],
  );

  const handleOnFilterLicenseOrBrand = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onFilter.licenseOrBrand(event.target.value);
    },
    [],
  );

  const handleSortByOptionsSelect = React.useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onFilter.sortBy(event.target.value);
    },
    [],
  );

  const handleOrderBySelect = React.useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onFilter.orderBy(event.target.value);
    },
    [],
  );

  return (
    <StyledTableContainer>
      {isLoading && <Loader />}
      <StyledFiltersContainer>
        <InputCheckbox
          customID="truck-report-table"
          label="Póliza Vencida"
          // checked={filterCheckboxValue}
          onChange={handleOnFilterInsurancePolicyExpired}
        />
        <InputText
          placeholder="Patente o Marca"
          label="Patente o Marca"
          onChange={handleOnFilterLicenseOrBrand}
        />
        <InputSelectList
          handleOnChange={onFilter.transport}
          handleOnInputChange={transportFilterQuery}
          options={transportFilterOptions}
          label="Transporte"
          placeholder="Transporte"
        />
      </StyledFiltersContainer>
      <StyledFiltersContainer>
        <InputSelect
          onChange={handleSortByOptionsSelect}
          options={sortByOptions}
          placeholder="Ordenar Por"
        />
        <InputSelect
          onChange={handleOrderBySelect}
          options={orderByOptions}
          placeholder="Ordenar Por"
        />
      </StyledFiltersContainer>
      <GenerateReportActions
        onGenerateReportPDF={onGenerateReportPDF}
        onGenerateReportXLXS={onGenerateReportXLXS}
      />
      <Table
        columns={columns}
        dataSource={newData}
        pagination={{
          position: ['bottomCenter'],
          showSizeChanger: false,
          ...paginationData,
        }}
      />
    </StyledTableContainer>
  );
};

export default TrucksReportsTable;
